import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceintathwadepune() {



const cardData = {
  keyword: " Cab Service in Tathawade Pune  ",

"headingDescription": "SRS Cab Service offers Cab Service in Tathawade Pune, providing reliable, comfortable, and efficient travel solutions for students, professionals, and families. Whether you need daily commuting, college travel, IT park transfers, airport pickups, or outstation cab services, our well-maintained vehicles and experienced drivers ensure a smooth and safe journey. With easy booking, transparent pricing, and 24/7 customer support, SRS Cab Service makes traveling in Tathawade convenient, timely, and completely hassle-free.",
"topPlaces": [
  {
    "title": "Indira College of Engineering and Management",
    "description": "A prominent educational institute in Tathawade attracting students and visitors. Travelers using Cab Service in Tathawade Pune from SRS Cab Service frequently commute here for academic purposes."
  },
  {
    "title": "JSPM Institutes",
    "description": "JSPM campus is a major educational hub in Tathawade. Visitors using SRS Cab Service often travel here for college-related activities and events."
  },
  {
    "title": "Symbiosis Skills and Professional University",
    "description": "A reputed university located near Tathawade. Travelers using SRS Cab Service frequently visit for academic and professional engagements."
  },
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "One of Pune’s largest IT hubs located near Tathawade. Business travelers using SRS Cab Service often commute here for office work."
  },
  {
    "title": "Balewadi High Street",
    "description": "A popular destination for dining, shopping, and nightlife. Visitors using SRS Cab Service often explore this area for entertainment and social outings."
  },
  {
    "title": "Baner Hills",
    "description": "Baner Hills is known for trekking and scenic views. Travelers using SRS Cab Service often visit for outdoor activities and relaxation."
  },
  {
    "title": "Sentosa Water Park",
    "description": "A well-known amusement and water park near Tathawade. Visitors using SRS Cab Service often visit for fun and family outings."
  },
  {
    "title": "Durga Tekdi",
    "description": "A green hill area offering peaceful surroundings and fresh air. Travelers using SRS Cab Service often visit for relaxation and morning walks."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "An educational and recreational destination for families and children. Visitors using SRS Cab Service often include it in their trips."
  },
  {
    "title": "Aundh",
    "description": "A nearby upscale area known for shopping malls and lifestyle hubs. Travelers using SRS Cab Service often visit for dining and shopping."
  }
],



services: [
{
name: "Tathawade Cab Service",
description: "Tathawade cab service offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Tathawade Pune",
description: "Taxi service in Tathawade Pune provides convenient travel for local and intercity routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Tathawade Taxi Service",
description: "Tathawade taxi service offers dependable transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Tathawade Pune",
description: "Cab booking Tathawade Pune provides quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Tathawade Pune",
description: "Taxi booking Tathawade Pune offers convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Tathawade Pune",
description: "Cab near Tathawade Pune helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Tathawade Pune",
description: "Taxi near Tathawade Pune offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Tathawade Pune",
description: "Best cab service in Tathawade Pune provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Tathawade",
description: "Cheap cab service Tathawade offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Tathawade",
description: "Affordable cab service Tathawade provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Tathawade Cab Hire",
description: "Tathawade cab hire offers flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Tathawade Taxi Hire",
description: "Tathawade taxi hire provides convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Tathawade Cab for Airport",
description: "Tathawade cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Tathawade Airport Cab Service",
description: "Tathawade airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Tathawade Cab for Outstation",
description: "Tathawade cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Tathawade Pune",
description: "Cab service Tathawade Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Tathawade Pune",
description: "Taxi service Tathawade Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Tathawade",
description: "Cab booking Tathawade provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab on Rent in Tathawade",
description: "Innova cab on rent in Tathawade offers spacious SUV travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab on Rent in Tathawade",
description: "Innova Crysta cab on rent in Tathawade provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab on Rent in Tathawade",
description: "Ertiga cab on rent in Tathawade offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab on Rent in Tathawade",
description: "Dzire cab on rent in Tathawade provides affordable sedan travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab on Rent in Tathawade",
description: "Sedan cab on rent in Tathawade offers budget-friendly travel for daily and outstation journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Luxury Cab on Rent in Tathawade",
description: "Luxury cab on rent in Tathawade provides premium travel experience for corporate and special trips. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury cab services."
},
{
name: "Tempo Traveller on Rent in Tathawade",
description: "Tempo traveller on rent in Tathawade offers group travel solutions for family and corporate trips. Customers can book vehicles for outstation journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania on Rent in Tathawade",
description: "Urbania on rent in Tathawade provides luxury group travel for large families and corporate trips. Customers can book premium vehicles for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
}
],

tableData: [
["Tathawade Cab Service","Taxi Service in Tathawade Pune"],
["Tathawade Taxi Service","Cab Booking Tathawade Pune"],
["Taxi Booking Tathawade Pune","Cab Near Tathawade Pune"],
["Taxi Near Tathawade Pune","Best Cab Service in Tathawade Pune"],
["Cheap Cab Service Tathawade","Affordable Cab Service Tathawade"],
["Tathawade Cab Hire","Tathawade Taxi Hire"],
["Tathawade Cab for Airport","Tathawade Airport Cab Service"],
["Tathawade Cab for Outstation","Cab Service Tathawade Pune"],
["Taxi Service Tathawade Pune","Cab Booking Tathawade"],
["Innova Cab on Rent in Tathawade","Innova Crysta Cab on Rent in Tathawade"],
["Ertiga Cab on Rent in Tathawade","Dzire Cab on Rent in Tathawade"],
["Sedan Cab on Rent in Tathawade","Luxury Cab on Rent in Tathawade"],
["Tempo Traveller on Rent in Tathawade","Urbania on Rent in Tathawade"]
],



whychoose: [
  {
    WhyChooseheading: "Premium Cab Service in Tathawade Pune",
    WhyChoosedescription: "SRS Cab Service offers top-quality cab service in Tathawade Pune for local rides, college travel, office commutes, airport transfers, and long-distance outstation trips with professional drivers and seamless booking."
  },
  {
    WhyChooseheading: "Affordable & Transparent Fare Structure",
    WhyChoosedescription: "We provide affordable cab service in Tathawade with completely transparent pricing. You get clear fare details including tolls, parking, and driver allowance without any hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "Our Tathawade cab service is available 24/7 for early morning airport drops, late-night pickups, emergency travel, and daily commuting needs."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars like Swift Dzire, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, Urbania vans, and luxury vehicles for all travel requirements."
  },
  {
    WhyChooseheading: "Clean, Safe & Comfortable Vehicles",
    WhyChoosedescription: "All our vehicles are regularly cleaned, sanitized, and well-maintained to provide maximum comfort, hygiene, and safety during your journey."
  },
  {
    WhyChooseheading: "Fast Doorstep Pickup Service",
    WhyChoosedescription: "We provide quick pickup from homes, societies, colleges, and offices in Tathawade and nearby areas like Wakad, Punawale, Ravet, and Hinjewadi."
  },
  {
    WhyChooseheading: "Best for Airport, IT & Outstation Travel",
    WhyChoosedescription: "Our cab service is perfect for Pune Airport transfers, Hinjewadi IT Park travel, Mumbai routes, business trips, and family vacations."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Tathawade",
    WhyChoosedescription: "SRS Cab Service is trusted by students, IT professionals, and families in Tathawade for punctual service, polite drivers, and reliable travel experience."
  }
]
}

const faqData = [
  { 
    question: "Do you provide cab service in Tathawade Pune?", 
    answer: "Yes, SRS Cab Service offers reliable cab service in Tathawade Pune for local travel, airport transfers, college commutes, and outstation trips. Our services are designed for students, professionals, and families looking for safe and comfortable travel." 
  },
  { 
    question: "Is cab service available 24 hours in Tathawade?", 
    answer: "Yes, our cab service in Tathawade operates 24/7. You can book a cab anytime for early morning flights, late-night travel, or urgent rides without worrying about availability." 
  },
  { 
    question: "Do you provide airport cab service from Tathawade?", 
    answer: "Yes, we provide Pune Airport pickup and drop services from Tathawade with on-time pickup, professional drivers, and smooth travel experience to ensure you never miss your flight." 
  },
  { 
    question: "Which areas do you cover near Tathawade?", 
    answer: "We cover Wakad, Punawale, Ravet, Hinjewadi, Baner, and nearby PCMC areas. Our cab service is available across Pune city and surrounding regions." 
  },
  { 
    question: "Which vehicles are available in Tathawade cab service?", 
    answer: "We offer a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, Urbania vans, and luxury cars for all travel needs." 
  },
  { 
    question: "Can I book cab online in Tathawade Pune?", 
    answer: "Yes, you can easily book cab service in Tathawade Pune online or via phone with instant confirmation and hassle-free booking process." 
  },
  { 
    question: "Do you provide outstation cab service from Tathawade?", 
    answer: "Yes, we provide outstation cab services from Tathawade to destinations like Mumbai, Nashik, Shirdi, Goa, Kolhapur, and more with comfortable long-distance travel options." 
  },
  { 
    question: "Is cab service suitable for students and IT professionals?", 
    answer: "Yes, our cab service is ideal for students traveling to colleges and IT professionals commuting to Hinjewadi IT Park, offering safe, reliable, and timely transport." 
  },
  { 
    question: "Are cab fares affordable in Tathawade?", 
    answer: "Yes, we offer affordable cab service in Tathawade with competitive pricing, transparent billing, and no hidden charges, ensuring value for money." 
  },
  { 
    question: "Are vehicles clean and drivers professional?", 
    answer: "Yes, all vehicles are regularly cleaned and sanitized, and our drivers are trained, experienced, and verified to ensure safe, comfortable, and stress-free travel." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "I booked a cab from Tathawade to Pune Airport and the experience was excellent. The driver arrived before time, the car was clean and comfortable, and the journey was smooth without any delays. Highly recommended service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Tathawade Pune. I booked for an outstation trip to Mumbai and the entire journey was very comfortable. The driver was polite, professional, and the pricing was very reasonable compared to others.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Tathawade Pune Cab Service",
  "description": "Reliable cab service in Tathawade, Pune with SRS Cab. Book taxis for local travel, airport transfers, and outstation trips. 24/7 service with Innova, Ertiga, sedan, SUV, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Tathawade",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411033",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.6230",
    "longitude": "73.7720"
  },
  "url": "https://www.srscabservice.com/tathawade-pune-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Tathawade, Pune"
  }
};








  return (
    <div>
      
<Helmet>
  <title>Cab Service in Tathawade Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Tathawade, Pune with SRS Cab. Local rides, airport transfers, and outstation trips available 24/7. Innova, Ertiga, sedan, SUV, and tempo traveller options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceintathwadepune;